import { useMonarchRule } from "../MonarchRulesProvider";
import { LearnPageRedesignData, UseLearnPageRedesign } from "./types";

const CUSTOM_RULE_ID = "learnPageRedesign";

const useLearnPageRedesign: UseLearnPageRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: LearnPageRedesignData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }
  // Determine variant based on enabled data
  const { data } = value;
  const variant = data?.enabled ? "test" : "control";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useLearnPageRedesign;
